<template>
  <div>
    <title-bar title="设备查看">
      <el-button type="primary" @click="showDayInfoEdit" v-if="me && me.supperAdmin">数据调整</el-button>
      <el-button type="primary" @click="showDayInfo">统计数据</el-button>
      <el-button type="primary" @click="settingVisible1 = true" v-if="device && device.deviceType !== '3'">参数设置</el-button>
      <el-button type="primary" @click="settingVisible2 = true" v-else>参数设置(PLC)</el-button>
      <el-button @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <device-view-base :device-code="deviceCode" v-if="!!deviceCode"></device-view-base>
      <el-row :gutter="10">
        <el-col :span="12">
          <device-real-time-template-chart class="real-time-temp" :device-code="deviceCode" v-if="!!deviceCode"></device-real-time-template-chart>
        </el-col>
        <el-col :span="12">
          <device-real-time-wet-chart class="real-time-wet" :device-code="deviceCode" v-if="!!deviceCode"></device-real-time-wet-chart>
        </el-col>
      </el-row>
      <device-month-run-chart :device-code="deviceCode" v-if="!!deviceCode"></device-month-run-chart>
<!--      <device-day-save-chart :device-code="deviceCode" v-if="!!deviceCode"></device-day-save-chart>-->
      <device-year-power-save-chart :device-code="deviceCode" v-if="!!deviceCode"></device-year-power-save-chart>
    </div>

    <device-setting-dialog :visible="true"
                           :device-code="deviceCode" v-if="!!deviceCode && settingVisible1"
                           width="80vw" title="设备参数设置"
                           @close="settingVisible1=false"></device-setting-dialog>

    <device-setting-dialog2 :visible="true"
                            :device-code="deviceCode" v-if="!!deviceCode && settingVisible2"
                            width="80vw" title="设备参数设置(吸尘式)"
                            @close="settingVisible2=false"></device-setting-dialog2>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import BaseVue from "@/components/base/BaseVue";
import DeviceViewBase from "@/components/device-view/DeviceViewBase";
import DeviceRealTimeTemplateChart from "@/components/device-view/DeviceRealTimeTemplateChart";
import DeviceRealTimeWetChart from "@/components/device-view/DeviceRealTimeWetChart";
import DeviceMonthRunChart from "@/components/device-view/DeviceMonthRunChart";
import DeviceYearPowerSaveChart from "@/components/device-view/DeviceYearPowerSaveChart";
import DeviceSettingDialog from "@/components/device-view/DeviceSettingDialog";
import DeviceSettingDialog2 from "@/components/device-view/DeviceSettingDialog2.vue";
import SessionStore from "@/utils/SessionStore";
import DeviceDaySaveChart from "@/components/device-view/DeviceDaySaveChart.vue";
export default {
  components: {
    DeviceDaySaveChart,
    DeviceSettingDialog2,
    DeviceSettingDialog,
    DeviceYearPowerSaveChart,
    DeviceMonthRunChart, DeviceRealTimeWetChart, DeviceRealTimeTemplateChart, DeviceViewBase, TitleBar},
  extends: BaseVue,
  data() {
    return {
      me: null,
      deviceCode: null,
      settingVisible1: false,
      settingVisible2: false,
      device: null
    }
  },
  created() {
    this.me = SessionStore.getUser();
    this.deviceCode = this.$route.query.deviceCode;
    this.loading = true;
    this.postForm("/device/getDevice", {
      deviceCode: this.deviceCode
    }, true).then(dr => {
      this.device = dr.bean || {};
    }).finally(()=>{
      this.loading = false;
    });
  },
  methods: {
    showDayInfo() {
      this.$router.push({
        path: "/deviceDayInfo",
        query: {
          deviceCode: this.deviceCode
        }
      })
    },
    showDayInfoEdit() {
      this.$router.push({
        path: "/deviceDayInfoEdit",
        query: {
          deviceCode: this.deviceCode
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.real-time-temp{
  margin-top:10px;
}
.real-time-wet{
  margin-top:10px;
}
</style>